var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lni-c-form-control",class:{
        'lni-c-form-control--required': _vm.required,
        'lni-c-form-control--inline': _vm.inline,
        'lni-c-form-control--custom-width': _vm.customWidth
    }},[_c('label',{staticClass:"lni-c-form-control__label",attrs:{"for":_vm.controlId}},[_vm._v(_vm._s(_vm.labelText))]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('input',{staticClass:"lni-c-form-control__input",attrs:{"type":"email","id":_vm.controlId,"name":_vm.controlId,"required":_vm.required,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"change":_vm.handleErrorState,"input":_vm.onInput}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2306598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/components/x-input-email/x-input-email.vue
// module id = 443
// module chunks = 0 1